var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvcVidoeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #73b9ff;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_92497",
    "data-name": "Group 92497",
    transform: "translate(-9.807 -9.931)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_39368",
    "data-name": "Ellipse 39368",
    className: "cls-1",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(9.807 9.931)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icons8-video-call",
    className: "cls-2",
    d: "M6.6,9A2.609,2.609,0,0,0,4,11.6v6.8A2.609,2.609,0,0,0,6.6,21h6.8A2.609,2.609,0,0,0,16,18.4v-.54l3.091,1.855A.6.6,0,0,0,20,19.2V10.8a.6.6,0,0,0-.909-.515L16,12.14V11.6A2.609,2.609,0,0,0,13.4,9Zm0,1.2h6.8a1.391,1.391,0,0,1,1.4,1.4v6.8a1.391,1.391,0,0,1-1.4,1.4H6.6a1.391,1.391,0,0,1-1.4-1.4V11.6A1.391,1.391,0,0,1,6.6,10.2Zm12.2,1.66v6.28L16,16.46V13.54Z",
    transform: "translate(13.807 10.931)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvcVidoeIcon);
export default __webpack_public_path__ + "static/media/avc_vidoe_icon.ffa3b2c0428174d94277f87fe105ee33.svg";
export { ForwardRef as ReactComponent };